import React from "react";
import LevelTestCard from "./LevelTestCard";

const testData = [
  {
    title: "Test HTML",
    percent: 45,
  },
  {
    title: "Test CSS",
    percent: 32,
  },
  {
    title: "Test JavaScript",
    percent: 60,
  },
];

const LevelTests = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
      {testData.map((test, index) => (
        <LevelTestCard key={index} title={test.title} percent={test.percent} />
      ))}
    </div>
  );
};

export default LevelTests;
